import React from 'react';
import PropTypes from 'prop-types';
import SelectorBase from './SelectorBase';
import i18nMessages from '../../../constants/messages/pt-BR';

function Radio(props) {
  const { className, color, ...other } = props;
  return (
    <SelectorBase type={i18nMessages.radio} className={className} {...other} />
  );
}

Radio.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  className: PropTypes.string,
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: PropTypes.oneOfType([PropTypes.object]),

  onChange: PropTypes.func,
  /**
   * The input component property `type`.
   */
  type: PropTypes.string,
  /**
   * The value of the component.
   */
  value: PropTypes.string,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const Radio = ({prop = val, checked = false, className = '', disabled = false, id = 'Radio-1', inputProps = { }) =>
Radio.defaultProps = {
  checked: false,
  className: '',
  disabled: false,
  id: 'Radio-1',
  inputProps: {},
  onChange: () => null,
  type: 'radio',
  value: '',
};

export default Radio;
